module.exports = __webpack_public_path__ + "iphone.1960dbbef071cf0439c2.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/images/cards/iphone.png
// module id = ../../../../../src/assets/images/cards/iphone.png
// module chunks = 0